import React from 'react';
import FeatureDescription from '../core/FeatureDescription';
import SectionH2 from '../heading/SectionH2';
import Buzzer from '../../img/buzzer.png';
import BuzzerOpenDoor from '../../img/buzzer_open_door.png';
import LandingPhone from '../app/LandingPhone';

const HowItWorks = ({ theme = 'dark' }) => {
  return (
    <div className="px-10">
      <div className="flex flex-col items-center pb-0 pt-1 sm:pb-8">
        <SectionH2 title={'How It Works'} theme={theme} />
        <div
          className={`max-w-4xl space-y-3 text-center font-space-grotesk-regular ${
            theme === 'dark' ? 'text-white' : 'text-black'
          }`}
        >
          <p>Lowkey lets residents and visitors buzz themselves in, so no one has to answer buzzer calls.</p>
          <p>Getting into any of your buildings takes 3 easy steps.</p>
        </div>
      </div>

      <div className="sm:flex sm:flex-row sm:justify-center sm:pt-5">
        <div className="flex max-w-7xl flex-col justify-center space-y-16 px-2 pt-16 sm:flex-row sm:space-x-8 sm:space-y-0 sm:px-0 sm:py-0 lg:space-x-12">
          <FeatureDescription
            customFontSize={'text-2xl lg:text-3xl'}
            title={'1. Share a passcode'}
            description={
              'Create a passcode for any building in the Lowkey app and share it with the residents, staff, or visitors who need access.'
            }
            image={<LandingPhone channel="business" kind="setup" className="h-80 w-auto" />}
            theme={theme}
          />
          <FeatureDescription
            customFontSize={'text-2xl lg:text-3xl'}
            title={'2. They dial the unit'}
            description={
              'From the buzzer, they dial the unit, either by entering the unit code or using the buzzer directory.'
            }
            secondaryDescription={'They are prompted to enter the Lowkey passcode after dialing the unit.'}
            imageSrc={Buzzer}
            imageAlt={'Building buzzer interface being pressed'}
            imageStyle="h-80 sm:h-68 lg:h-80 rounded-3xl"
            theme={theme}
          />
          <FeatureDescription
            customFontSize={'text-2xl lg:text-3xl'}
            title={'3. They are buzzed in'}
            description={'Lowkey buzzes them in automatically, no one has to answer a phone to grant access.'}
            imageSrc={BuzzerOpenDoor}
            imageAlt={'Person being buzzed in and entering the building'}
            imageStyle="h-80 sm:h-68 lg:h-80 rounded-3xl"
            theme={theme}
          />
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
